
import {Vue, Component, Watch} from 'vue-property-decorator';
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import SayfaAciklama from "@/components/SayfaAciklama.vue";
import OzelAralikDatePicker from "@/components/infos/raporlama-ofispro/helper-comps/OzelAralikDatePicker.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import {IBen} from "@/interface/IBen";
import {LisansEntity} from "@/entity/LisansEntity";

@Component({
  components: {OzelAralikDatePicker, SayfaAciklama, DeleteDialog}
})
export default class OfisPropUyarilar extends Vue {
  tab = 0;
  search: string = "";
  uyarilarItems:any= []
  tebligatBildirimleri:any=[]
  kesinlesmeDisabled:boolean = false;
  id= null
  secilenDosyalar = []
  menuItems = [
    {icon:'mdi-account-outline',title:'İş Ata'},
    {icon:'mdi-printer-outline',title:'Yazdır'},
    {icon:'mdi-download-outline',title:'İndir'},
    {icon:'mdi-arrow-right-bottom',title:'Taşı'},
  ]
  onFly = false;

  // Pagination state properties
  currentPage: number = 1;
  totalItems: number = 0;
  itemsPerPage: number = 20;  // Default from API
  lastPage: number = 1;  // Last page number from API
  currentWarningType: string = '';
  loading: boolean = false;

  // ID to API warning type key mapping
  private warningTypeMap: { [key: number]: string } = {
    2: 'adres-arastirma',
    3: 'barkod-sorgusu',
    4: 'kesinlestirme',
    5: 'gonderildigi-tarih',
    6: 'haciz_talebinde_bulunulacak_dosyalar',
    7: 'itiraz-davasi',
    8: 'mal-beyani',
    9: 'mernis',
    10: 'mersis',
    11: '35-e-gore',
    12: '21-e-gore',
    // Haciz types - to be confirmed with backend API
    14: 'hacize_gidilecek_dosyalar',
    15: 'haciz_tarihi_girilecek_dosyalar',
    16: 'seksen_dokuz_iki_ihbarname_gonderilecekler',
    17: 'seksen_dokuz_uc_ihbarname_gonderilecekler',
    18: 'maas_haczi_muzakeresi_gonderilecekler',
    19: 'muzakere_tebligi_kontrol_edilecekler',
    20: 'yuz_uc_davetiyesi_gonderilecekler',
    21: 'kiymet_takdiri_istenecekler',
    // İşlemsizlikten Düşecek Dosyalar
    22: 'islemsizlikten-dusecek-dosyalar',
  };

  get tooltip(){
    let tooltip:string = ''
    if (this.lisanslar){
      tooltip = "Toplu Kesinleştirme  Talebi Özelliğini Kullanmak İçin E-İcraPro'ya Sahip Olmanız Lazım"
    }else{
      tooltip = 'Toplu Kesinleşme Talebi Gönder'

    }
    return tooltip
  }

  get lisanslar(){
    let kesinlestirme : boolean = false
    this.$store.getters.licenses.forEach((license:any) => {
      if (license.id == 3 && this.secilenDosyalar.length>0) {
        kesinlestirme = false
      }else {
        kesinlestirme = true
      }
    });
    return kesinlestirme
  }
  async allCreateTask(){
    let tasks: Array<Task> = [];


    this.secilenDosyalar.forEach((items:any) => {
      let borcluBilgileri:any = {
        adi:items.borclu.kisi?items.borclu.kisi.ad:null,
        soyadi:items.borclu.kisi?items.borclu.kisi.soyad:null,
        kurumAdi:items.borclu.kurum?items.borclu.kurum.sirket_adi:null
      }
      let borcluData

      if(items.borclu.kisi){
        borcluData = {id:items.borclu.id,borcluBilgileri:borcluBilgileri,
          tc:items.borclu.kisi.tc_kimlik_no,vergi_kimlik:null,mersis_no:null}
      }else{

        borcluData = {id:items.borclu.id,borcluBilgileri:borcluBilgileri,
          tc:null,vergi_kimlik:items.borclu.kurum.vergi_no ,mersis_no:items.borclu.kurum.mersis_no}
      }
      let task: Task = new Task();
      task.dosya_esas_no = items.borclu.takip.dosya_esas_no;
      task.birim_adi = items.borclu.takip.icra_dairesi.isim;
      task.dosya_id = (items.borclu.takip.id).toString();
      task.task_type_id = TaskTuru.toplu_genel_talep_hazirla;
      task.data = {
        params: {
          "hacizParams": {},
          "digerTalepParams": [
            {
              "grupKodu": 2,
              "talepKodu": 31,
              "talepAdi": "Takibin Kesinleşmesi",
              "talepKisaAdi": "Takibin Kesinleşmesi",
              "talepMasrafi": 0,
              "className": "AvukatTalepGenelTakibiKesinlestirDVO",
              "postaMasrafId": 0,
              "dosyaDurum": "A"
            }
          ]
        },
        borclu: borcluData,
        isKisiBool:items.borclu.kisi?true:false
      };
      tasks.push(task);

    })
    await this.$store.dispatch('postTasks', tasks)
        await this.$router.push(ProgramPaths.eicrapro + '/islemler')

  }

  // Fetch warnings from paginated API
  async fetchWarnings(warningType: string, page: number = 1) {
    this.loading = true;
    try {
      const response: any = await this.$http.get(
        `/api/v1/uyarilar/${warningType}?page=${page}`
      );

      // Axios interceptor unwraps response.data automatically
      // Response: { data: [...items...], total: 199, current_page: 1, last_page: 10 }
      if (response && Array.isArray(response.data)) {
        this.tableItems = response.data;
        // Use actual total from API - Vuetify will calculate pages correctly
        this.totalItems = response.total || 0;
        this.lastPage = response.last_page || 1;
        this.currentPage = response.current_page || page;
      } else {
        this.tableItems = [];
        this.totalItems = 0;
        this.lastPage = 1;
      }

      this.currentWarningType = warningType;
    } catch (error) {
      console.error('İtem Yüklenirken Hata:', error);
      this.tableItems = [];
      this.totalItems = 0;
    } finally {
      this.loading = false;
    }
  }

  // Handle data table options change (includes pagination)
  async onOptionsChange(options: any) {
    if (this.currentWarningType && options.page) {
      // Limit page to lastPage from API
      const requestedPage = Math.min(options.page, this.lastPage);
      // Prevent fetching if already on the correct page
      if (requestedPage !== this.currentPage) {
        await this.fetchWarnings(this.currentWarningType, requestedPage);
      }
    }
  }

  // TODO: Re-implement with count API endpoint
  // bildirims(key:any){
  //   this.tebligatBildirimleri = this.bildirimShow.find((x:any) => x.key === key)
  //   return this.tebligatBildirimleri ? this.tebligatBildirimleri.length : 0;
  // }

  // get tebligatBildiirims(){
  //   let tebligatBildiirim = 0
  //   this.bildirimShow.forEach((bildirim:any)=>{
  //     tebligatBildiirim+=bildirim.length
  //   })
  //   return tebligatBildiirim
  // }

  // get bildirimShow(){
  //   const bildirimCount: any = [];
  //   Object.keys(this.uyarilarItems).forEach((key) => {
  //     const items = this.uyarilarItems[key]
  //     bildirimCount.push({key:key,length:items.length})
  //   });
  //   return bildirimCount;
  // }

  async handleItems(id:number){
    // Get warning type from mapping
    const warningType = this.warningTypeMap[id];

    if (!warningType) {
      return;
    }

    // Reset page to 1 when switching warning types
    this.currentPage = 1;

    if (id!=4 && id!=1){
      this.kesinlesmeDisabled = false
    }
    if(id==2){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'bila_tarihi')) {
        this.headers.splice(2, 0, { text: 'Bila Tarihi', value: 'bila_tarihi' });
        this.headers.splice(2, 0, { text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' });
      }

      await this.fetchWarnings(warningType, 1);

    }else if(id==3){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'tebligat_gonderim_tarihi')) {
        this.headers.splice(2, 0, { text: 'Tebligat Gönderim Tarihi', value: 'tebligat_gonderim_tarihi' });
      }

      await this.fetchWarnings(warningType, 1);

    }else if(id==4){
      this.kesinlesmeDisabled = true

      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'kesainlesme_talebi_gonderim_tarihi')) {
        this.headers.splice(2, 0, { text: 'Kesinlesme Talebi Gönderim Tarihi', value: 'kesainlesme_talebi_gonderim_tarihi' });
      }

      await this.fetchWarnings(warningType, 1);

    }else if(id==5){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'tarih')) {
        this.headers.splice(2, 0, { text: 'Takip Tarihi', value: 'tarih' });
      }

      await this.fetchWarnings(warningType, 1);

    }else if(id==6){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'kesinlesme_tarihi')) {
        this.headers.splice(2, 0, {text: 'Kesinleşme Tarihi', value: 'kesinlesme_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);

    }else if(id==7){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'itiraz_tarihi')) {
        this.headers.splice(2, 0, {text: 'İtiraz Tarihi', value: 'itiraz_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==8){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'kesinlesme_tarihi')) {
        this.headers.splice(2, 0, {text: 'Kesinleşme Tarihi', value: 'kesinlesme_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==9){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'bila_tarihi')) {
        this.headers.splice(2, 0, { text: 'Bila Tarihi', value: 'bila_tarihi' });
        this.headers.splice(2, 0, { text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' });
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==10){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'bila_tarihi')) {
        this.headers.splice(2, 0, { text: 'Bila Tarihi', value: 'bila_tarihi' });
        this.headers.splice(2, 0, { text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' });
      }
      await this.fetchWarnings(warningType, 1);
    }else if(id==11){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'bila_tarihi')) {
        this.headers.splice(2, 0, { text: 'Bila Tarihi', value: 'bila_tarihi' });
        this.headers.splice(2, 0, { text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' });
      }
      await this.fetchWarnings(warningType, 1);
    }else if(id==12){
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'bila_tarihi')) {
        this.headers.splice(2, 0, { text: 'Bila Tarihi', value: 'bila_tarihi' });
        this.headers.splice(2, 0, { text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' });
      }
      await this.fetchWarnings(warningType, 1);
    } else if(id==14){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'hacize_gidis_tarihi')) {
        this.headers.splice(2, 0, {text: 'Hacize Gidiş Tarihi', value: 'hacize_gidis_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }
    else if(id==15){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'talep_tarihi')) {
        this.headers.splice(2, 0, {text: 'Talep Tarihi', value: 'talep_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }
    else if(id==16){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'seksen_dokuz_bir_ihbarname_teblig_tarihi')) {
        this.headers.splice(2, 0, {text: "89-1'de İhbarnamenin Tebliğ Tarihi", value: 'seksen_dokuz_bir_ihbarname_teblig_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==17){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'seksen_dokuz_iki_ihbarname_teblig_tarihi')) {
        this.headers.splice(2, 0, {text: "89-2'de İhbarnamenin Tebliğ Tarihi", value: 'seksen_dokuz_iki_ihbarname_teblig_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==18){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'talebin_kabul_edildigi_tarihi')) {
        this.headers.splice(2, 0, {text: "Talebin Kabul Edildiği Tarihi", value: 'talebin_kabul_edildigi_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==19){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'muzakere_gonderildigi_tarih')) {
        this.headers.splice(2, 0, {text: "Müzakerenin Gönderildiği Tarih", value: 'muzakere_gonderildigi_tarih'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==20){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'fiilen_haciz_tarihi')) {
        this.headers.splice(2, 0, {text: "Fiilen Haciz Tarihi", value: 'fiilen_haciz_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==21){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
      this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

      if (!this.headers.some(header => header.value === 'haciz_tarihi')) {
        this.headers.splice(2, 0, {text: "Haciz Tarihi", value: 'haciz_tarihi'});
      }

      await this.fetchWarnings(warningType, 1);
    }else if(id==22){

      this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'tarih');
      this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'hacize_gidis_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talep_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_bir_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'seksen_dokuz_iki_ihbarname_teblig_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'talebin_kabul_edildigi_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'muzakere_gonderildigi_tarih');
      this.headers = this.headers.filter(header => header.value !== 'fiilen_haciz_tarihi');
      this.headers = this.headers.filter(header => header.value !== 'haciz_tarihi');

      if (!this.headers.some(header => header.value === 'kart_numarasi')) {
        this.headers.splice(2, 0, {text: 'Kart Numarası', value: 'kart_numarasi'});
        this.headers.splice(3, 0, {text: 'Dosya Esas Numarası', value: 'dosya_esas_numarasi'});
        this.headers.splice(4, 0, {text: 'Geçen Gün Sayısı', value: 'gecen_gun_sayisi'});
      }

      const warningType = this.warningTypeMap[id];
      await this.fetchWarnings(warningType, 1);
    }
  }

  mounted(){
    // Remove unnecessary headers on component mount
    this.headers = this.headers.filter(header => header.value !== 'kesainlesme_talebi_gonderim_tarihi');
    this.headers = this.headers.filter(header => header.value !== 'bila_tarihi');
    this.headers = this.headers.filter(header => header.value !== 'kesinlesme_tarihi');
    this.headers = this.headers.filter(header => header.value !== 'tebligat_gonderim_tarihi');
    this.headers = this.headers.filter(header => header.value !== 'talebin_gonderildigi_tarih');
    this.headers = this.headers.filter(header => header.value !== 'itiraz_tarihi');
    this.headers = this.headers.filter(header => header.value !== 'kart_numarasi');
    this.headers = this.headers.filter(header => header.value !== 'dosya_esas_numarasi');
    this.headers = this.headers.filter(header => header.value !== 'gecen_gun_sayisi');

    // Data will be loaded when user clicks a warning type via handleItems
    // No initial API call needed - removed old get-uyarilar endpoint

    this.lisanslar;
  }


  headers = [
    {
      text: '',
      align: 'start',
      sortable: false,
      class: 'my-header-style'
    },
    {text: 'İçerik', value: 'message',align:'start' },
    {text: 'Takip Tarihi', value: 'tarih'},
    {text: 'Kesinlesme Talebi Gönderim Tarihi', value: 'kesainlesme_talebi_gonderim_tarihi'},
    {text: 'Bila Tarihi', value: 'bila_tarihi'},
    {text: 'Tebligat Gönderim Tarihi', value: 'tebligat_gonderim_tarihi'},
    {text: 'Kesinleşme Tarihi', value: 'kesinlesme_tarihi'},
    {text: 'Talebin Gönderildiği Tarih', value: 'talebin_gonderildigi_tarih' },
    {text: 'İtiraz Tarihi', value: 'itiraz_tarihi'},
    {text: 'Hacize Gidiş Tarihi', value: 'hacize_gidis_tarihi'},
    {text: 'Talep Tarihi', value: 'talep_tarihi'},
    {text: "89-1'de İhbarnamenin Tebliğ Tarihi", value: 'seksen_dokuz_bir_ihbarname_teblig_tarihi'},
    {text: "89-2'de İhbarnamenin Tebliğ Tarihi", value: 'seksen_dokuz_iki_ihbarname_teblig_tarihi'},
    {text: "Talebin Kabul Edildiği Tarihi", value: 'talebin_kabul_edildigi_tarihi'},
    {text: "Müzakerenin Gönderildiği Tarih", value: 'muzakere_gonderildigi_tarih'},
    {text: "Fiilen Haciz Tarihi", value: 'fiilen_haciz_tarihi'},
    {text: "Haciz Tarihi", value: 'haciz_tarihi'},
    {text: 'Kart Numarası', value: 'kart_numarasi'},
    {text: 'Dosya Esas Numarası', value: 'dosya_esas_numarasi'},
    {text: 'Geçen Gün Sayısı', value: 'gecen_gun_sayisi'},
    {text: 'İşlemler', value: 'actions',align: 'end'},
  ]

  tableItems:any = []

  items = [
    {id: 1, name: 'Tebligat Uyarıları',
      children: [
        {id: 2,key:'adres_arastirma_yapilacaklar_listesi', name: "Adres Araştırması Y."},
        {id: 3,key:'barkod_sorgusu_yapilacaklar_ve_tebligat_bilgisi_girilecekler', name: "Barkod Sorgusu ve Tebligat Bilgisi.G."},
        {id: 4,key:'dosyanin_kesinlestirilmesi_talebi_g_d_l', name: "Dosyanın Kesinleştirilmesi T.G."},
        {id: 5,key:'gonderildigi_tarih_girilecekler', name: "Gönderildiği Tarih G."},
        {id: 6,key:'haciz_talebinde_bulunulacak_dosyalar', name: "Haciz Talebinde B.D."},
        {id: 7,key:'itirazin_iptali_kaldirilmasi_d_a_d', name: "İtirazın İptali/Kaldırılması D.A.D"},
        {id: 8,key:'mal_beyaninda_bulunmama_sebebiyle_d_a_d', name: "Mal Beyanında Bulunmama Sebebiyle D.A.D"},
        {id: 9,key:'mernis_adresine_tebligat_yapilacak_dosyalar', name: "Mernis Adresine Tebligat Y.D"},
        {id: 10,key:'mersis_adresine_tebligat_yapilacak_dosyalar', name: "Mersis Adresine Tebligat Y.D"},
        {id: 11,key:'otuzbes_gore_tebligat_talep_edilecek_dosyalar', name: "35'e Göre Tebligat T.E.D"},
        {id: 12,key:'yirmibir_gore_tebligat_talep_edilecek_dosyalar', name: "21'e Göre Tebligat T.E.D"},
      ],
    },
   {
      id: 13,
      name: 'Haciz Uyarıları',
      children: [
        {id: 14,key:'', name: "Hacize Gidilecek D."},
        {id: 15,key:'', name: "Hacize Tarihi Girilecek D."},
        {id: 16,key:'', name: "89-2 İhbarnamesi Gönderilecekler"},
        {id: 17,key:'', name: "89-3 İhbarnamesi Gönderilecekler"},
        {id: 18,key:'', name: "Maaş Haczi Müzakersi Gönderilecekler"},
        {id: 19,key:'', name: "Müzakere Tebliği Kontrol Edilecekler"},
        {id: 20,key:'', name: "103 Davetiyesi Gönderilecekler"},
        {id: 21,key:'', name: "Kıymet Takdiri İstenecekler"},
      ],
    },
    {
      id: 22,
      name: 'İşlemsizlikten Düşecek Dosyalar',
      children: [],
    },
    /*
 {
   id: 15,
   name: 'Satış Uyarıları',
   children: [],
 },
 {
   id: 16,
   name: 'Satış Sonrası Uyarıları',
   children: [],
 },
 {
   id: 17,
   name: 'Manuel Uyarılar',
   children: [],
 }*/
  ]


  getTakipDetay(item:any){
    this.$router.push(ProgramPaths.icrapro + '/takip/' + item.kart_numarasi);
  }

  calculateDaysPassed(sonIslemTarihi: string): number {
    if (!sonIslemTarihi) return 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lastActionDate = new Date(sonIslemTarihi);
    lastActionDate.setHours(0, 0, 0, 0);
    const diffTime = today.getTime() - lastActionDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }
}
